
import axios from 'axios';
import React, { Component } from 'react';
import PeriodicalHighlightsPriority from '../../Components/Periodical-Highlights-Priority/Periodical-Highlights-Priority';
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ModalBuscarConteudo from '../../Components/Modal-Buscar-Conteudo/Modal-Buscar-Conteudo';





class PeriodicalHighlights extends Component {
    constructor(props) {
        super(props);

        this.voltar = this.voltar.bind(this);
        this.carregaListaDestaquesPeriodico = this.carregaListaDestaquesPeriodico.bind(this);
        this.handleError = this.handleError.bind(this);
        this.atualizarDestaque = this.atualizarDestaque.bind(this);
        this.toggleModalBuscarConteudo = this.toggleModalBuscarConteudo.bind(this);
        this.carregaUltimosArtigosPublicados = this.carregaUltimosArtigosPublicados.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.buscarTermos = this.buscarTermos.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.state = {
            listaDestaquesPeriodicos: [],
            isLoadingDestaquesPeriodicos: true,
            posicaoModal: 0,
            listaArtigos: [],
            isLoadingArtigos: false,
            openModalBuscarConteudo: false,
            termo: '',
            ordenacao: "date"
        }

        this.Configurations = new Configurations();
    }

    componentDidMount() {
        this.carregaListaDestaquesPeriodico();
        this.carregaUltimosArtigosPublicados();
    }

    voltar() {
        window.history.go(-1);
    }

    carregaListaDestaquesPeriodico() {
        this.setState({ isLoadingDestaquesPeriodicos: true });
        axios.get(this.Configurations.apiBasePath + `/destaques-veiculos/${this.props.match.params.periodico}`).then(response => {
            this.setState({
                listaDestaquesPeriodicos: response.data.destaques
            })
        }).catch(this.handleError)
            .finally(() => this.setState({ isLoadingDestaquesPeriodicos: false }))

    }

    carregaUltimosArtigosPublicados() {
        this.setState({ isLoadingArtigos: true });
        axios.get(this.Configurations.apiBasePath + `/conteudo/artigos/publicados/ultimos?veiculo=${this.props.match.params.periodico}`).then(response => {
            this.setState({
                listaArtigos: response.data.artigos

            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingArtigos: false }))
    }

    atualizarDestaque(idConteudo) {
        this.setState({ isLoadingDestaquesPeriodicos: true })
        const _body = {
            idConteudo: idConteudo,
            posicao: this.state.posicaoModal
        };

        axios.put(this.Configurations.apiBasePath + `/destaques-veiculos/${this.props.match.params.periodico}/atualizar`, _body)
            .then(response => {
                this.carregaListaDestaquesPeriodico();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingDestaquesPeriodicos: false }));

        this.setState({
            openModalBuscarConteudo: !this.state.openModalBuscarConteudo
        })
    }

    toggleModalBuscarConteudo(posicao) {
        if (!this.state.openModalBuscarConteudo) {
            this.setState({
                termo: "",
                ordenacao: "date"
            })

            this.carregaUltimosArtigosPublicados();
        }

        this.setState({
            openModalBuscarConteudo: !this.state.openModalBuscarConteudo,
            posicaoModal: posicao,

        })

    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    buscarTermos(e) {
        e.preventDefault();
        this.setState({ isLoadingArtigos: true });
        axios.get(this.Configurations.apiBasePath + `/conteudo/artigos/busca/${this.state.termo}?ordem=${this.state.ordenacao}&veiculo=${this.props.match.params.periodico}`).then(response => {
            this.setState({
                listaArtigos: response.data.artigos
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingArtigos: false }));

    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        return (
            <div className="row destaques-periodico">
                <div className="col-12">
                    <div className="row no-gutters border-bottom border-dark">
                        <div className="col-9">
                            <h2>Destaques do Periódico - {this.props.match.params.periodico.toUpperCase()}</h2>
                        </div>
                        <div className="col-3 text-right">
                            <button className="btn btn-outline-secondary" type="button" name="voltar" onClick={this.voltar}>Voltar</button>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-9 py-3 text-center">
                    {this.state.isLoadingDestaquesPeriodicos ? (
                        <div className="spinner-border text-primary" role="status" />
                    ) : (
                        <div className="row no-gutters">
                            <div className="col-12">
                                <PeriodicalHighlightsPriority
                                    item={this.state.listaDestaquesPeriodicos.filter(item => item.posicao === 1)[0]
                                        || {}}
                                    atualizarDestaque={this.atualizarDestaque}
                                    toggle={this.toggleModalBuscarConteudo}
                                    prioridade={1}
                                />
                            </div>
                            <div className="col-6 pr-2">
                                <PeriodicalHighlightsPriority
                                    item={this.state.listaDestaquesPeriodicos.filter(item => item.posicao === 2)[0]
                                        || {}}
                                    atualizarDestaque={this.atualizarDestaque}
                                    toggle={this.toggleModalBuscarConteudo}
                                    prioridade={2}
                                />
                            </div>
                            <div className="col-6 pl-2">
                                <PeriodicalHighlightsPriority
                                    item={this.state.listaDestaquesPeriodicos.filter(item => item.posicao === 3)[0]
                                        || {}}
                                    atualizarDestaque={this.atualizarDestaque}
                                    toggle={this.toggleModalBuscarConteudo}
                                    prioridade={3}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="col-lg-3 py-4">
                    <div className="card">
                        <div className="card-body bg-primary text-left text-white">
                            <h4 className="m-0">Frase da Semana</h4>
                        </div>
                    </div>
                </div>
                <ModalBuscarConteudo
                    toggle={this.toggleModalBuscarConteudo}
                    isOpen={this.state.openModalBuscarConteudo}
                    posicao={this.state.posicaoModal}
                    periodico={this.props.match.params.periodico.toUpperCase()}
                    listaArtigos={this.state.listaArtigos}
                    atualizarDestaque={this.atualizarDestaque}
                    handleChange={this.handleChange}
                    buscarTermos={this.buscarTermos}
                    handleSelect={this.handleSelectOrdenacao}
                    termo={this.state.termo}
                    ordenacao={this.state.ordenacao}
                    match={this.props.match}
                    history={this.props.history}
                />
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
            </div>

        )
    }
}

export default PeriodicalHighlights;